import { cn } from '@workspace/ui/lib/utils'
import Markdown from 'react-markdown'
import remarkGfm from 'remark-gfm'

interface ProseProps extends Omit<React.HTMLAttributes<HTMLDivElement>, 'children'> {
  children?: string | null
}

export function Prose({ children, className, ...rest }: ProseProps) {
  if (!children) return null

  return (
    <div
      {...rest}
      className={cn(
        'prose prose-sm dark:prose-invert prose-ul:my-1 prose-li:my-0 max-w-none [&_strong]:text-foreground [&_a]:text-[#f97316] [&_a]:underline',
        className
      )}
    >
      <Markdown
        remarkPlugins={[remarkGfm]}
        components={{
          p: ({ children }) => <p className="mb-3 last:mb-0">{children}</p>,
        }}
      >
        {children}
      </Markdown>
    </div>
  )
}
